import { render, staticRenderFns } from "./NativeNotificationPrompt.vue?vue&type=template&id=15c71f1f&scoped=true&"
import script from "./NativeNotificationPrompt.vue?vue&type=script&lang=js&"
export * from "./NativeNotificationPrompt.vue?vue&type=script&lang=js&"
import style0 from "./NativeNotificationPrompt.vue?vue&type=style&index=0&id=15c71f1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c71f1f",
  null
  
)

export default component.exports